import { render, staticRenderFns } from "./ClipTxt.vue?vue&type=template&id=00217de9&"
import script from "./ClipTxt.vue?vue&type=script&lang=js&"
export * from "./ClipTxt.vue?vue&type=script&lang=js&"
import style0 from "./ClipTxt.vue?vue&type=style&index=0&id=00217de9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports